/* ── Каталог ────────────────────────────────────────────────────────── */

.list {
  display: grid;
  gap: var(--sp-3);
}

.spread {
  display: grid;
  grid-template-columns: 4.5rem 1fr;
  gap: var(--sp-4);
  align-items: center;
  padding: var(--sp-4);
  text-align: left;
  border: 1px solid var(--c-border-subtle);
  border-radius: var(--r-lg);
  background: var(--c-surface);
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    background var(--dur-fast) var(--ease-standard);
}

.spread:hover,
.spread:focus-visible {
  border-color: var(--c-border-strong);
  background: var(--c-surface-raised);
}

.spreadBody {
  display: grid;
  gap: var(--sp-1);
  min-width: 0;
}

.spreadFoot {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-3);
  margin-top: var(--sp-1);
}

/* Цена — сакральное, как и баланс в шапке: её не нажимают. */
.price {
  flex: none;
  font: var(--t-numeric-m);
  font-variant-numeric: tabular-nums;
  color: var(--c-sacred);
}

.priceOut {
  color: var(--c-text-tertiary);
}

/*
   Силуэт раскладки.

   Те же доли, что и у настоящих карт на столе: один источник геометрии.
   Пропорция коробки здесь фиксированная — силуэт передаёт форму,
   а не расстояния.
*/
.silhouette {
  position: relative;
  aspect-ratio: 1 / 1.15;
  border-radius: var(--r-sm);
  background: var(--c-bg-canvas);
  border: 1px solid var(--c-border-subtle);
}

.silhouetteCard {
  position: absolute;
  width: 22%;
  aspect-ratio: 5 / 8;
  translate: -50% -50%;
  border-radius: 1px;
  background: var(--c-sacred);
  opacity: 0.55;
}

/* ── Расклад до тасовки ─────────────────────────────────────────────── */

.back {
  align-self: flex-start;
  padding: var(--sp-1) 0;
  color: var(--c-text-tertiary);
  font: var(--t-label-m);
}

.back:hover {
  color: var(--c-text-secondary);
}

.positions {
  display: grid;
  gap: var(--sp-2);
  list-style: none;
}

.position {
  display: grid;
  grid-template-columns: 1.5rem 1fr;
  gap: var(--sp-3);
  align-items: baseline;
}

.positionIdx {
  font: var(--t-numeric-m);
  font-variant-numeric: tabular-nums;
  color: var(--c-sacred);
  text-align: right;
}

/* ── Тасовка ────────────────────────────────────────────────────────── */

.commit {
  display: grid;
  gap: var(--sp-1);
  justify-items: center;
  text-align: center;
}

/*
   Отпечаток и секрет.

   Моноширинный и с переносом по любому символу: это шестнадцатеричная
   строка без пробелов, и без break-all она уедет за край экрана.
   Читать её целиком не нужно — нужно видеть, что она одна и та же
   до тасовки и после.
*/
.hash {
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 0.6875rem;
  line-height: 1.5;
  color: var(--c-text-tertiary);
  word-break: break-all;
}

/* ── Стол ───────────────────────────────────────────────────────────── */

.table {
  position: relative;
  width: 100%;
  margin-block: var(--sp-2);
}

.slot {
  position: absolute;
  translate: -50% -50%;
  display: grid;
  justify-items: center;
  gap: var(--sp-1);
}

.slotLabel {
  font: var(--t-caption);
  color: var(--c-text-tertiary);
  text-align: center;
  white-space: nowrap;
}

.meaning {
  padding-bottom: var(--sp-4);
  border-bottom: 1px solid var(--c-border-subtle);
}

.reversedMark {
  color: var(--c-text-tertiary);
  font: var(--t-body-s);
}

/* ── Проверка ───────────────────────────────────────────────────────── */

.steps {
  display: grid;
  gap: var(--sp-5);
  list-style: none;
}

.step {
  display: grid;
  grid-template-columns: 1.75rem 1fr;
  gap: var(--sp-3);
}

.stepN {
  display: grid;
  place-items: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--r-pill);
  border: 1px solid var(--c-border-sacred);
  color: var(--c-sacred);
  font: var(--t-numeric-m);
}

.stepBody {
  min-width: 0;
}

.checkOk,
.checkBad {
  display: flex;
  align-items: baseline;
  gap: var(--sp-2);
}

.checkOk {
  color: var(--c-sacred);
}

.checkBad {
  color: var(--c-danger);
}

.verdictBad {
  display: grid;
  gap: var(--sp-2);
  padding: var(--sp-4);
  border-radius: var(--r-md);
}

.proofTable {
  width: 100%;
  border-collapse: collapse;
  font: var(--t-body-s);
  font-variant-numeric: tabular-nums;
}

.proofTable th {
  text-align: left;
  padding-block: var(--sp-2);
  color: var(--c-text-tertiary);
  font: var(--t-caption);
  border-bottom: 1px solid var(--c-border-subtle);
}

.proofTable td {
  padding-block: var(--sp-2);
  border-bottom: 1px solid var(--c-border-subtle);
}
